/**
 * Cache localStorage CRM Salon — stale-while-revalidate.
 * Invalidé à la création / édition / archive d’un salon.
 */

const EVENTS_KEY = 'crm_salon_events_cache_v1'
const JOURNEE_KEY = 'crm_salon_journee_cache_v2'
const TTL_MS = 30 * 60 * 1000 // 30 min

function readJson(key) {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return null
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

function writeJson(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    // quota / private mode — ignore
  }
}

export function getCachedEvents(includeArchived) {
  const pack = readJson(EVENTS_KEY)
  if (!pack || !Array.isArray(pack.items)) return null
  if (!!pack.includeArchived !== !!includeArchived) return null
  if (pack.at && Date.now() - pack.at > TTL_MS) {
    // stale OK for display, caller still refreshes
  }
  return pack.items
}

export function setCachedEvents(includeArchived, items) {
  writeJson(EVENTS_KEY, {
    at: Date.now(),
    includeArchived: !!includeArchived,
    items: items || []
  })
}

export function journeeCacheKey(eventId, day) {
  return String(eventId || 'auto') + '|' + String(day || 'all')
}

export function getCachedJournee(eventId, day) {
  const pack = readJson(JOURNEE_KEY)
  if (!pack || !pack.data) return null
  if (pack.key !== journeeCacheKey(eventId, day)) return null
  return pack.data
}

export function setCachedJournee(eventId, day, data) {
  writeJson(JOURNEE_KEY, {
    at: Date.now(),
    key: journeeCacheKey(eventId, day),
    data
  })
}

/** Après mutation salon : force rechargement réseau. */
export function invalidateSalonCaches() {
  try {
    localStorage.removeItem(EVENTS_KEY)
    localStorage.removeItem(JOURNEE_KEY)
  } catch (e) {}
}

/** Après une visite : stats Journée à rafraîchir. */
export function invalidateJourneeCache() {
  try {
    localStorage.removeItem(JOURNEE_KEY)
  } catch (e) {}
}
